'use client';

import Image from 'next/image';

import { Container } from '../Container';
import backgroundImage from '@/images/background-call-to-action.jpg';
import { CallToActionBlock } from '@/payload-types';
import RichText from './LocalityRichText';
import { CMSLink } from '../CMSLink';
import { useLocalityService } from '@/providers/Locality';

const LocalityCallToAction: React.FC<CallToActionBlock> = (data) => {
  const { links, richText } = data;

  const localityService = useLocalityService();

  return (
    <section
      id="get-started-today"
      className="relative overflow-hidden bg-blue-600 xsmall:py-20 lg:py-16"
    >
      <Image
        className="absolute left-1/2 top-1/2 max-w-none -translate-x-1/2 -translate-y-1/2"
        src={backgroundImage}
        alt=""
        width={2347}
        height={1244}
        // Pas de `unoptimized` : il court-circuite l'optimiseur de Next, qui
        // servait donc le JPEG source de 4694x2488 tel quel (166 Ko) a tous les
        // visiteurs. Avec `sizes`, Next produit un srcset en largeurs plafonne
        // par `deviceSizes` (1200) et negocie l'AVIF : 2,7 Ko pour le meme rendu.
        // La largeur de mise en page est fixe (2347px) quel que soit le viewport,
        // l'image debordant puis etant rognee par l'`overflow-hidden` du parent.
        sizes="2347px"
      />
      <Container className="relative">
        <div className="mx-auto max-w-6xl text-center">
          {richText && (
            <RichText
              data={richText}
              className="text-white lg:[&_h2]:text-3xl"
            />
          )}
          {links?.map((link) => {
            link.link.label = localityService.replaceTags(link.link.label);

            return (
              <CMSLink
                key={link.id}
                {...link.link}
                className="group mt-10 inline-flex mx-auto items-center justify-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-slate-900 hover:bg-blue-50 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2"
              />
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export { LocalityCallToAction };
